import {
  Link,
  Breadcrumbs as MuiBreadcrumbs,
  Divider as MuiDivider,
  TextField,
  Typography,
  makeStyles,
} from "@material-ui/core";
import GovGrTabs from "../../components/GovGrTabs";

import ApplicationsForCitizen from "./ApplicationsForCitizen";
import ApplicationsForPortAuth from "./ApplicationsForPortAuth";
import { Autocomplete } from "@material-ui/lab";
import { Helmet } from "react-helmet-async";
import { NavLink } from "react-router-dom";
import { fetchPortAuthorities } from "../../services/portAuthoritiesService";
import { spacing } from "@material-ui/system";
import styled from "styled-components/macro";
import useLocale from "../../hooks/useLocale";
import { useQuery } from "react-query";
import { useSelector } from "react-redux";
import { useState } from "react";
import { portAuthoritySort } from "../../utils/portAuthoritySort";
import GovGrCard from "../../components/GovGrCard";

const Divider = styled(MuiDivider)(spacing);
const Breadcrumbs = styled(MuiBreadcrumbs)(spacing);

const useStyles = makeStyles({
  viewDetails: {
    width: 700,
    height: 400,
  },
  card: {
    marginTop: "1rem",
    marginBottom: "1.5rem",
  },
  applicationCard: {
    maxWidth: "80vw",
  },
});

const ApplicationsEdit = () => {
  const { t } = useLocale();

  const [portAuthId, setportAuthId] = useState(
    useSelector((state) => state?.authReducer?.user?.port_auth_id)
  );
  const auth_level = useSelector(
    (state) => state?.authReducer?.user?.auth_level
  );
  const tabs = [
    {
      id: 0,
      tabName: t("Applications waiting Port Authority action"),
      component: <ApplicationsForPortAuth key={0} portAuthId={portAuthId} />,
    },
    {
      id: 1,
      tabName: t("Applications waiting citizen action"),
      component: <ApplicationsForCitizen key={1} portAuthId={portAuthId} />,
    },
  ];
  const {
    data: PortAuthorities,
    isError,
    isLoading,
    refetch,
  } = useQuery("portAuthorities", fetchPortAuthorities);

  // Get portAuthorities Sorted via requirements (sort them by City with 1st DNER)
  const portAuthoritiesSorted = portAuthoritySort(PortAuthorities);

  return (
    <>
      <Helmet title={t("Edit Applications")} />
      <Typography variant="h3" gutterBottom display="inline">
        {t("Edit Applications")}
      </Typography>

      <Breadcrumbs aria-label="Breadcrumb" mt={2}>
        <Link component={NavLink} exact to="/">
          {t("Dashboard")}
        </Link>
        <Typography>{t("Edit Applications")}</Typography>
      </Breadcrumbs>

      <Divider my={6} />
      {auth_level === 0 || auth_level === 4 ? (
        <GovGrCard>
          <Autocomplete
            id="combo-box-demo"
            onChange={(event, newValue) => {
              setportAuthId(newValue?.id);
            }}
            options={portAuthoritiesSorted || []}
            getOptionLabel={(option) => option?.dscr}
            style={{ width: 300, marginTop: 10 }}
            renderInput={(params) => (
              <TextField
                {...params}
                label={t("Port Authorities")}
                variant="outlined"
              />
            )}
          />
        </GovGrCard>
      ) : null}

      <GovGrTabs
        inputTable={auth_level === 4 ? tabs.filter((t) => t.id === 1) : tabs}
      />
    </>
  );
};

export default ApplicationsEdit;
